import React, {useEffect, useContext} from 'react';
import UserContext from './../contexts/UserContext';
import {Container,ProgressBar} from 'react-bootstrap';

import Utils from './../Utils';

import {useParams} from "react-router-dom";

const PackageSelector = (props) => {
  
  const {setPackage,selectedPackage} = useContext(UserContext);  

  const { pkg } = useParams();

  useEffect(()=>{    
    setPackage(pkg);    
    window.setTimeout(() => {      
      window.location.href= process.env.PUBLIC_URL + (Utils.isLoggedIn() ?  (selectedPackage() ? '/pay' : '/../#buy-now') : '/register');
    },1000);
  },[]);


  return <Container className="text-center"><p>loading..<br /><ProgressBar className="mt-2" animated variant="primary" now={100} /></p></Container>;

}

export default PackageSelector;